import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Layout, Menu } from 'antd'
import { HomeOutlined } from '@ant-design/icons'

import { ReactComponent as CollectionSvg } from '../assets/sidebar/Collections.svg'
import { ReactComponent as PaymentSvg } from '../assets/sidebar/Payment.svg'
import { ReactComponent as UserSvg } from '../assets/sidebar/User.svg'
import { ReactComponent as FundingSvg } from '../assets/sidebar/Funding.svg'
import { ReactComponent as DeductionSvg } from '../assets/sidebar/Deduction.svg'
import RegionSelect from './RegionSelect'
const { Sider } = Layout

const CollectionSimulatorForm: React.FC = () => {
    const [collapsed, setCollapsed] = useState(true)

    function getItem(label: string, key: string, icon: JSX.Element) {
        return {
            key,
            icon,
            label,
        }
    }

    const items = [
        getItem('Home', '/', <HomeOutlined />),
        getItem('Collection', '/collection', <CollectionSvg width={35} className="svg-icon" />),
        getItem('User', '/user', <UserSvg width={35} className="svg-icon" />),
        getItem('Simple Payment', '/simple_payment', <PaymentSvg width={35} className="svg-icon" />),
        getItem('Funding', '/funding', <FundingSvg width={35} className="svg-icon" />),
        getItem('Deduction', '/deduction', <DeductionSvg width={35} className="svg-icon" />),
    ]
    const location = useLocation()
    const navigate = useNavigate()

    console.log(location)

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: '#fff',
                position: 'sticky',
                top: 0,
                height: '100vh',
            }}
        >
            <Sider trigger={null} theme="light" breakpoint="sm" collapsible collapsed={collapsed}>
                <div className="logo" onClick={() => setCollapsed(!collapsed)} />
                <Menu
                    theme="light"
                    mode="inline"
                    items={items}
                    selectedKeys={[location.pathname]}
                    onClick={(item) => {
                        navigate(item.key)
                    }}
                />
            </Sider>
            <div
                style={{
                    width: '100%',
                }}
            >
                <RegionSelect collapsed={collapsed} />
            </div>
        </div>
    )
}

export default CollectionSimulatorForm
